// extracted by css-extract-rspack-plugin
export default {"BarGroup":"BarGroup--_O_5X"};